export const grupoConstants = {
    GRUPO_GETPU_SUCCESS: 'GRUPO_GETPU_SUCCESS',
    ROL_ADMIN:1,
    ROL_USER_ADMIN:3,
    ROL_USER:2,
    ROL_DESARROLLADOR:4,
    REMOVER_AUTORIZACION:'REMOVER_AUTORIZACION',
    ELIMINAR_AUTORIZACION:'ELIMINAR_AUTORIZACION'
};
